var map = {
	"./1.png": "45fc",
	"./2.png": "fe95",
	"./3.png": "3438",
	"./4.png": "ce56",
	"./5.png": "7fc5",
	"./6.png": "2ed6",
	"./default.png": "c10e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e52b";